module.exports = require("ioredis");